<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">
                    Draggable Image List
                </div>
            </div>
            <!--page content-->
            <!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div class="form-group">
                    <label for="categories">Select One Category</label>
                    <v-select v-model="categoryId"
                              @change="changedValue"
                              @input="changedCategoryFor()"
                              name="categoryId"
                              id="categoryId"
                              label="text"
                              :filterable="false"
                              :options="categoryArr"
                              @search="onSearchCategory"
                              placeholder="Select Category">
                        <template slot="no-options">
                            Search Parent Category...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>-->

            <div class="admin-page-content">
                <draggable v-model="leadershipList" v-on:change="changePosition()" class="drag-view">
                    <template v-for="(text, index) in leadershipList">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <span v-if="text.video_path != ''" class="btn edit-btn-vvg waves-effect"><!--First video-->
                                <video width="250" controls="controls" preload="metadata">
                                    <source :src="text.video_path + '#t=0.5'" type="video/mp4">
                                </video>
                                <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> {{text.video_title}} </h3>
                            </span>
                            <span v-if="text.video_url != ''" class="btn edit-btn-vvg waves-effect">
                                <iframe v-if="text.video_url != ''" :src="text.video_url" controls width="250" height="100"></iframe>
                                <h3 class="leading-title float-l width-full color-blue heading-text-20 line-height-24 font-text-semi-medium-mont pt-28"> {{text.video_title}} </h3>
                            </span>
                        </div>
                    </template>
                </draggable>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import vSelect from 'vue-select';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                categoryId: '',
                categoryArr: [],
                categoryType: 'leadership',
                leadershipList: [],
            }
        },
        watch: {
            categoryId: function (categoryId) {
                self.getLeadershipDevelopment();
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.MenuClose();
            self.loadCategoryFirst();
        },

        methods: {
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionleadership", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            deleteVideo: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletemedia", config)
                                .then(function (response) {
                                    self.getImages();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            loadCategoryFirst() {
//                var addAll = {text: 'All', value: '0'};
//                self.categoryArr.push(addAll);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = [];
                            var addAll = {text: 'All', value: '0'};
                            self.categoryArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                self.categoryArr.push(response.data.content[i]);
                            });
                            self.categoryId = addAll;
//                        self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedCategoryFor: function () {

            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {loading(false);}
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            getLeadershipDevelopment: function () {
                var fields = {
                    categoryId: self.categoryId.value,
                    categoryType: self.categoryType,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('getleadershipdevelopment/' + self.categoryId.value, fields, config).
                        then(response => {
                            self.leadershipList = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/leadershipdevelopment/ListLeadershipMedia.vue